import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import {
  fetchCart,
  updateProduct,
  updateProducts,
  removeCartProduct,
} from './data-source';
import { IValueProduct } from '@shared/types.ts';
import { useUser } from '../authorization/use-user.ts';

export function useCartService({
  onUpdate,
}: {
  onUpdate?: (products: IValueProduct[]) => void;
}) {
  const { isAuthenticated } = useUser();
  const { isLoading, data } = useSWR(
    isAuthenticated ? `/api/baskets` : null,
    fetchCart,
    {
      onSuccess: (response) => {
        if (response?.basket_items) {
          const products: IValueProduct[] = response.basket_items.map((i) => {
            return {
              ...i.product,
              value: i.quantity,
            };
          });
          onUpdate?.(products);
        }
      },
    }
  );

  const updateProductInCart = useSWRMutation(`/api/baskets`, updateProduct);
  const updateProductsInCart = useSWRMutation(
    `/api/baskets/add`,
    updateProducts
  );
  const removeProductFromCart = useSWRMutation(
    `/api/basket-items`,
    removeCartProduct
  );

  return {
    data,
    updateProductInCart,
    updateProductsInCart,

    isLoading,
    removeProductFromCart,
  };
}
